import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.resize(true);
        this.windowWidth = window.innerWidth;

        this.bindResize = this.resize.bind(this);
        window.addEventListener('resize', this.bindResize);
    }

    resize(firstHit = false) {
        if(this.windowWidth != window.innerWidth) {
            this.windowWidth = window.innerWidth;
            this.windowHeight = window.innerHeight;

            if(this.windowWidth < this.windowHeight) {
                if(!this.isMobile || firstHit) {
                    this.el.setAttribute('src', this.el.getAttribute('data-mobile-src'));
                }
                this.isMobile = true;
            } else {
                if(this.isMobile || firstHit) {
                    this.el.setAttribute('src', this.el.getAttribute('data-desktop-src'));
                }
                this.isMobile = false;
            }
        }
    }

    destroy() {
        window.removeEventListener('resize', this.bindResize);
    }
}
